import Typography from '@material-ui/core/Typography'
import { Variant } from '@material-ui/core/styles/createTypography'
import { voidF } from 'types/FunctionTypes'
import { messageColor } from 'types/ReferTypes'

type Props = {
  message: string
  color?: messageColor
  link?: boolean
  align?: 'left' | 'center' | 'right'
  variant?: Variant
  onClick?: voidF
}

const getStyle = (color: string) => {
  switch (color) {
    case 'red':
      return { color: 'red' }
    case 'blue':
      return { color: 'blue' }
    case 'green':
      return { color: 'green' }
  }
  return { color: 'red' }
}

/**
 * メッセージ表示ATOM
 * @param message メッセージ
 * @param color 'red'/'blue'/'green' デフォルトは'red'
 * @param link boolean デフォルトはfalse
 * @param align 'reft'/'center'/'right' デフォルトは'left'
 * @returns
 */
const A_Message = ({ color = 'red', message, link = false, align = 'left', onClick = () => {}, variant = 'caption' }: Props) => {
  if (link) {
    return (
      <p style={{ textAlign: `${align}`, color: 'blue', cursor: 'pointer', textDecoration: 'underline' }}>
        <div onClick={onClick}>ユーザー追加はこちら</div>
      </p>
    )
  }
  return (
    <Typography variant={variant} display="block" align={align} onClick={onClick} gutterBottom>
      <b style={getStyle(color)}>{message}</b>
    </Typography>
  )
}
export default A_Message
